<template>
  <div class="menu w-100 h-100 position-fixed">
    <div class="column d-inline-block position-absolute"></div>
    <div class="column d-inline-block position-absolute"></div>
    <div class="column d-inline-block position-absolute"></div>
    <div class="column d-inline-block position-absolute"></div>

    <div class="menu-content w-100 h-100">
      <div class="container h-100">
        <div class="row h-100 align-items-center justify-content-around">
          <div class="col-auto text-center mt-5">
            <div class="menu-list mb-md-5">

              <a href="https://www.lappui.org/fr/je-suis-aidant/contenus-inspirants/le-balado-des-histoires-qui-resonnent-saison-2/" targte="_blank" class="text-white h2-5 d-block font-weight-bold">Le balado</a>
              <router-link :to="{name: 'BaladoTestimonial'}" class="text-white h2-5 d-block mt-4">
                <button class="h2-5 btn btn-outline-light font-weight-bold">
                  <span>Témoignez</span>
                </button>
              </router-link>
            </div>
            <a href="https://www.lappui.org/" target="_blank">
              <img id="logoMenu" src="/images/Logo_Appui_Nav.svg" alt="Logo Appui Nav" class="mt-4" height="35">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data: () => ({
    displaySubMenu: false,
  }),
  methods: {
  },
  updated() {
    // this.displaySubMenu = false;
    // this.displaySubMenu = false;
    // console.log('menu-updated')
  }
}
</script>

<style scoped>

  #logoMenu {
    height:40px;
  }
</style>
